app.commonController = app.commonController || {};

app.commonController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        $( document ).ready(function() {
            app.globalController.indexAction.init();
            app.navController.indexAction.init();
            app.headerController.indexAction.init();
            app.modalController.indexAction.init();
            app.mapsController.indexAction.init();
            app.formsController.indexAction.init();
            app.lazyloadController.indexAction.init();
            app.backtoptopController.indexAction.init();
            app.equipeController.indexAction.init();
//            app.portfolioController.indexAction.init();
        });
    }
    
    
};